import * as React from 'react';
import { RentalLinkInfo } from 'common/types';
import { StaticContext } from 'react-router';
import { Redirect, Link, RouteComponentProps } from 'react-router-dom';

import { Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import Container from 'components/Container';
import LinkButton from 'common/components/LinkButton';
import Typography from '@mui/material/Typography';
import { ReduxState } from 'services/types';
import { connect } from 'react-redux';
import { Routes } from 'routing';
import { useTranslation, Trans } from 'services/localization';

interface StateToProps {
	rentalLinkSendingFailed: boolean;
}

type LocationState = {
	rentalLink: RentalLinkInfo;
};

type Props = WithStyles<typeof styles> &
	RouteComponentProps<{}, StaticContext, LocationState> &
	StateToProps;

const RentalLinkSent = (props: Props) => {
	const { t } = useTranslation();
	const classes = props.classes;
	const state: { rentalLink: RentalLinkInfo } = props.location.state;
	if (!state) {
		return <Redirect to={Routes.NEW_RENTAL} />;
	}
	const rentalLink = state.rentalLink;
	if (!rentalLink) {
		return <Redirect to={Routes.NEW_RENTAL} />;
	}
	const { email, phone } = rentalLink;
	return (
		<Container className={classes.root}>
			<div className={classes.sentInfo}>
				<Typography variant="h5" gutterBottom color="textPrimary">
					{t('payLinkConfirm.sentInfo', 'Great! Rental link sent to')}:
				</Typography>
				{email !== null && (
					<Typography variant="h6" gutterBottom>
						{email}
					</Typography>
				)}
				{phone !== null && (
					<Typography variant="h6" gutterBottom>
						{phone}
					</Typography>
				)}
			</div>
			<Typography variant="body1">
				{
					<Trans
						i18nKey="payLinkConfirm.statusInfo"
						defaults="You can check the status of the payment from the <rentals>Rentals page</rentals>"
						components={{
							rentals: (
								<Link className={classes.link} to={Routes.Bookings()}>
									{'Rentals page'}
								</Link>
							),
						}}
					/>
				}
			</Typography>
			<div className={classes.btnBlockWrapper}>
				<LinkButton variant="contained" color="primary" to={Routes.NEW_RENTAL}>
					{t('payLinkConfirm.takeNewRental')}
				</LinkButton>
			</div>
		</Container>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			flex: '1 1 auto',
			textAlign: 'center',
		},
		sentInfo: {
			marginBottom: 16,
		},
		btnBlockWrapper: {
			display: 'block',
			textAlign: 'center',
			margin: 32,
		},
		link: {
			color: theme.palette.primary.main,
		},
	});

const mapStateToProps = ({ view }: ReduxState): StateToProps => {
	return {
		rentalLinkSendingFailed: view.rentalLinkSendingFailed,
	};
};

export default withStyles(styles)(connect(mapStateToProps)(RentalLinkSent));
